import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type { PaymentsSettingsSaveRequest, ResponseData } from "../../../../graphql/types"

export const savePaymentSettingsMutation = (
    headers: Record<string, any>,
    data: PaymentsSettingsSaveRequest
): Promise<ResponseData> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation paymentsSettingsSave($data: PaymentsSettingsSaveRequest!) {
                    paymentsSettingsSave(data: $data) {
                        success
                    }
                }
            `,
            operationName: "paymentsSettingsSave",
            variables: {
                data: data,
            },
        },
    }).then(response => response.data.paymentsSettingsSave)
